// extracted by mini-css-extract-plugin
export default {"imgBlock":"imgBlock_JUQW7"};